/* eslint-disable react/react-in-jsx-scope */
import React from "react";
interface Props {
  color: string;
}
export const Search: React.FC<Props> = ({ color }) => (
  <path
    d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
    fill={color}
  />
);
export const Done: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_78313)">
      <path
        d="M8.9999 16.2L4.7999 12L3.3999 13.4L8.9999 19L20.9999 6.99998L19.5999 5.59998L8.9999 16.2Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_78313">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const ForwardArrowIOS: React.FC<Props> = ({ color }) => (
  <path
    d="M7.38048 21.0098C7.87048 21.4998 8.66048 21.4998 9.15048 21.0098L17.4605 12.6998C17.8505 12.3098 17.8505 11.6798 17.4605 11.2898L9.15048 2.9798C8.66048 2.4898 7.87048 2.4898 7.38048 2.9798C6.89048 3.4698 6.89048 4.2598 7.38048 4.7498L14.6205 11.9998L7.37048 19.2498C6.89048 19.7298 6.89048 20.5298 7.38048 21.0098Z"
    fill={color}
  />
);

export const BackArrowIOS: React.FC<Props> = ({ color }) => (
  <path
    d="M16.6196 2.99006C16.1296 2.50006 15.3396 2.50006 14.8496 2.99006L6.53957 11.3001C6.14957 11.6901 6.14957 12.3201 6.53957 12.7101L14.8496 21.0201C15.3396 21.5101 16.1296 21.5101 16.6196 21.0201C17.1096 20.5301 17.1096 19.7401 16.6196 19.2501L9.37957 12.0001L16.6296 4.75006C17.1096 4.27006 17.1096 3.47006 16.6196 2.99006Z"
    fill={color}
  />
);

export const ArrowDropdown: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_92243)">
      <path
        d="M8.70956 11.71L11.2996 14.3C11.6896 14.69 12.3196 14.69 12.7096 14.3L15.2996 11.71C15.9296 11.08 15.4796 10 14.5896 10H9.40956C8.51956 10 8.07956 11.08 8.70956 11.71Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_92243">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const ArrowDropUp: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_92249)">
      <path
        d="M8.70956 12.2902L11.2996 9.70021C11.6896 9.31021 12.3196 9.31021 12.7096 9.70021L15.2996 12.2902C15.9296 12.9202 15.4796 14.0002 14.5896 14.0002H9.40956C8.51956 14.0002 8.07956 12.9202 8.70956 12.2902Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_92249">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Check: React.FC<Props> = ({ color }) => (
  <path
    d="M8.99965 16.1698L5.52965 12.6998C5.13965 12.3098 4.50965 12.3098 4.11965 12.6998C3.72965 13.0898 3.72965 13.7198 4.11965 14.1098L8.29965 18.2898C8.68965 18.6798 9.31965 18.6798 9.70965 18.2898L20.2896 7.70982C20.6796 7.31982 20.6796 6.68982 20.2896 6.29982C19.8997 5.90982 19.2696 5.90982 18.8796 6.29982L8.99965 16.1698Z"
    fill={color}
  />
);

export const Close: React.FC<Props> = ({ color }) => (
  <path
    d="M18.2997 5.71022C17.9097 5.32022 17.2797 5.32022 16.8897 5.71022L11.9997 10.5902L7.10973 5.70021C6.71973 5.31021 6.08973 5.31021 5.69973 5.70021C5.30973 6.09021 5.30973 6.72022 5.69973 7.11022L10.5897 12.0002L5.69973 16.8902C5.30973 17.2802 5.30973 17.9102 5.69973 18.3002C6.08973 18.6902 6.71973 18.6902 7.10973 18.3002L11.9997 13.4102L16.8897 18.3002C17.2797 18.6902 17.9097 18.6902 18.2997 18.3002C18.6897 17.9102 18.6897 17.2802 18.2997 16.8902L13.4097 12.0002L18.2997 7.11022C18.6797 6.73022 18.6797 6.09022 18.2997 5.71022Z"
    fill={color}
  />
);

export const Mail: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_92021)">
      <path
        d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L13.06 12.34C12.41 12.75 11.59 12.75 10.94 12.34L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_92021">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Photo: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_91575)">
      <path
        d="M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.9 13.98L11 16.51L14.1 12.52C14.3 12.26 14.7 12.26 14.9 12.53L18.41 17.21C18.66 17.54 18.42 18.01 18.01 18.01H6.02C5.6 18.01 5.37 17.53 5.63 17.2L8.12 14C8.31 13.74 8.69 13.73 8.9 13.98Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_91575">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const PhotoLibrary: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_91588)">
      <path
        d="M22 16V4C22 2.9 21.1 2 20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16ZM11.4 12.53L13.03 14.71L15.61 11.49C15.81 11.24 16.19 11.24 16.39 11.49L19.35 15.19C19.61 15.52 19.38 16 18.96 16H9C8.59 16 8.35 15.53 8.6 15.2L10.6 12.53C10.8 12.27 11.2 12.27 11.4 12.53ZM2 7V20C2 21.1 2.9 22 4 22H17C17.55 22 18 21.55 18 21C18 20.45 17.55 20 17 20H5C4.45 20 4 19.55 4 19V7C4 6.45 3.55 6 3 6C2.45 6 2 6.45 2 7Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_91588">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const AddPhotoAlt: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_91156)">
      <path
        d="M21.02 5H19V2.98C19 2.44 18.56 2 18.02 2H17.99C17.44 2 17 2.44 17 2.98V5H14.99C14.45 5 14.01 5.44 14 5.98V6.01C14 6.56 14.44 7 14.99 7H17V9.01C17 9.55 17.44 10 17.99 9.99H18.02C18.56 9.99 19 9.55 19 9.01V7H21.02C21.56 7 22 6.56 22 6.02V5.98C22 5.44 21.56 5 21.02 5ZM16 9.01V8H14.99C14.46 8 13.96 7.79 13.58 7.42C13.21 7.04 13 6.54 13 5.98C13 5.62 13.1 5.29 13.27 5H5C3.9 5 3 5.9 3 7V19C3 20.1 3.9 21 5 21H17C18.1 21 19 20.1 19 19V10.72C18.7 10.89 18.36 11 17.98 11C16.89 10.99 16 10.1 16 9.01ZM15.96 19H6C5.59 19 5.35 18.53 5.6 18.2L7.58 15.57C7.79 15.29 8.2 15.31 8.4 15.59L10 18L12.61 14.52C12.81 14.26 13.2 14.25 13.4 14.51L16.35 18.19C16.61 18.52 16.38 19 15.96 19Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_91156">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const CopyContent: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_90181)">
      <path
        d="M15 1H4C2.9 1 2 1.9 2 3V16C2 16.55 2.45 17 3 17C3.55 17 4 16.55 4 16V4C4 3.45 4.45 3 5 3H15C15.55 3 16 2.55 16 2C16 1.45 15.55 1 15 1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM18 21H9C8.45 21 8 20.55 8 20V8C8 7.45 8.45 7 9 7H18C18.55 7 19 7.45 19 8V20C19 20.55 18.55 21 18 21Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_90181">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const CopyFile: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_90213)">
      <path
        d="M15 1H4C2.9 1 2 1.9 2 3V16C2 16.55 2.45 17 3 17C3.55 17 4 16.55 4 16V4C4 3.45 4.45 3 5 3H15C15.55 3 16 2.55 16 2C16 1.45 15.55 1 15 1ZM15.59 5.59L20.42 10.42C20.79 10.79 21 11.3 21 11.83V21C21 22.1 20.1 23 19 23H7.99C6.89 23 6 22.1 6 21L6.01 7C6.01 5.9 6.9 5 8 5H14.17C14.7 5 15.21 5.21 15.59 5.59ZM15 12H19.5L14 6.5V11C14 11.55 14.45 12 15 12Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_90213">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Mic: React.FC<Props> = ({ color }) => (
  <path
    d="M12 14C13.66 14 15 12.66 15 11V5C15 3.34 13.66 2 12 2C10.34 2 8.99999 3.34 8.99999 5V11C8.99999 12.66 10.34 14 12 14ZM17.91 11C17.42 11 17.01 11.36 16.93 11.85C16.52 14.2 14.47 16 12 16C9.52999 16 7.47999 14.2 7.06999 11.85C6.98999 11.36 6.57999 11 6.08999 11C5.47999 11 4.99999 11.54 5.08999 12.14C5.57999 15.14 7.97999 17.49 11 17.92V20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20V17.92C16.02 17.49 18.42 15.14 18.91 12.14C19.01 11.54 18.52 11 17.91 11Z"
    fill={color}
  />
);

export const MicNone: React.FC<Props> = ({ color }) => (
  <path
    d="M12 14C13.66 14 15 12.66 15 11V5C15 3.34 13.66 2 12 2C10.34 2 8.99999 3.34 8.99999 5V11C8.99999 12.66 10.34 14 12 14ZM11 5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5V11C13 11.55 12.55 12 12 12C11.45 12 11 11.55 11 11V5ZM17.91 11C17.42 11 17.01 11.36 16.93 11.85C16.52 14.2 14.47 16 12 16C9.52999 16 7.47999 14.2 7.06999 11.85C6.98999 11.36 6.57999 11 6.08999 11C5.47999 11 4.99999 11.54 5.08999 12.14C5.57999 15.14 7.97999 17.49 11 17.92V20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20V17.92C16.02 17.49 18.42 15.14 18.91 12.14C19.01 11.54 18.52 11 17.91 11Z"
    fill={color}
  />
);

export const MicOff: React.FC<Props> = ({ color }) => (
  <path
    d="M15 10.6V5C15 3.34 13.66 2 12 2C10.46 2 9.20998 3.16 9.03998 4.65L15 10.6ZM18.08 11C17.67 11 17.31 11.3 17.25 11.71C17.2 12.03 17.13 12.35 17.03 12.64L18.3 13.91C18.6 13.31 18.82 12.66 18.93 11.97C19 11.46 18.6 11 18.08 11ZM3.70998 3.56C3.31998 3.95 3.31998 4.58 3.70998 4.97L8.99998 10.27V10.7C8.99998 11.89 9.59998 13.02 10.63 13.61C11.38 14.04 12.04 14.05 12.65 13.92L14.31 15.58C13.6 15.91 12.81 16.1 12 16.1C9.45998 16.1 7.11998 14.33 6.74998 11.71C6.68998 11.3 6.32998 11 5.91998 11C5.39998 11 4.99998 11.46 5.06998 11.97C5.52998 14.93 8.02998 17.27 11 17.72V20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20V17.72C13.91 17.59 14.77 17.27 15.55 16.82L19.04 20.31C19.43 20.7 20.06 20.7 20.45 20.31C20.84 19.92 20.84 19.29 20.45 18.9L5.11998 3.56C4.72998 3.17 4.09998 3.17 3.70998 3.56Z"
    fill={color}
  />
);

export const Pause: React.FC<Props> = ({ color }) => (
  <path
    d="M8 19C9.1 19 10 18.1 10 17V7C10 5.9 9.1 5 8 5C6.9 5 6 5.9 6 7V17C6 18.1 6.9 19 8 19ZM14 7V17C14 18.1 14.9 19 16 19C17.1 19 18 18.1 18 17V7C18 5.9 17.1 5 16 5C14.9 5 14 5.9 14 7Z"
    fill={color}
  />
);

export const Play: React.FC<Props> = ({ color }) => (
  <path
    d="M8 6.81976V17.1798C8 17.9698 8.87 18.4498 9.54 18.0198L17.68 12.8398C18.3 12.4498 18.3 11.5498 17.68 11.1498L9.54 5.97976C8.87 5.54976 8 6.02976 8 6.81976Z"
    fill={color}
  />
);

export const Save: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_90320)">
      <path
        d="M19 13V18C19 18.55 18.55 19 18 19H6C5.45 19 5 18.55 5 18V13C5 12.45 4.55 12 4 12C3.45 12 3 12.45 3 13V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V13C21 12.45 20.55 12 20 12C19.45 12 19 12.45 19 13ZM13 12.67L14.88 10.79C15.27 10.4 15.9 10.4 16.29 10.79C16.68 11.18 16.68 11.81 16.29 12.2L12.7 15.79C12.31 16.18 11.68 16.18 11.29 15.79L7.7 12.2C7.31 11.81 7.31 11.18 7.7 10.79C8.09 10.4 8.72 10.4 9.11 10.79L11 12.67V4C11 3.45 11.45 3 12 3C12.55 3 13 3.45 13 4V12.67Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_90320">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Send: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_90326)">
      <path
        d="M3.4 20.4L20.85 12.92C21.66 12.57 21.66 11.43 20.85 11.08L3.4 3.60002C2.74 3.31002 2.01 3.80002 2.01 4.51002L2 9.12002C2 9.62002 2.37 10.05 2.87 10.11L17 12L2.87 13.88C2.37 13.95 2 14.38 2 14.88L2.01 19.49C2.01 20.2 2.74 20.69 3.4 20.4Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_90326">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Sort: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_90329)">
      <path
        d="M4 18H8C8.55 18 9 17.55 9 17C9 16.45 8.55 16 8 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7ZM4 13H14C14.55 13 15 12.55 15 12C15 11.45 14.55 11 14 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_90329">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const VolumeDown: React.FC<Props> = ({ color }) => (
  <path
    d="M18.5 11.9998C18.5 10.2298 17.48 8.70977 16 7.96977V16.0198C17.48 15.2898 18.5 13.7698 18.5 11.9998ZM5 9.99977V13.9998C5 14.5498 5.45 14.9998 6 14.9998H9L12.29 18.2898C12.92 18.9198 14 18.4698 14 17.5798V6.40977C14 5.51977 12.92 5.06977 12.29 5.69977L9 8.99977H6C5.45 8.99977 5 9.44977 5 9.99977Z"
    fill={color}
  />
);

export const VolumeUp: React.FC<Props> = ({ color }) => (
  <path
    d="M3 10.0001V14.0001C3 14.5501 3.45 15.0001 4 15.0001H7L10.29 18.2901C10.92 18.9201 12 18.4701 12 17.5801V6.41008C12 5.52008 10.92 5.07008 10.29 5.70008L7 9.00008H4C3.45 9.00008 3 9.45008 3 10.0001ZM16.5 12.0001C16.5 10.2301 15.48 8.71008 14 7.97008V16.0201C15.48 15.2901 16.5 13.7701 16.5 12.0001ZM14 4.45008V4.65009C14 5.03009 14.25 5.36009 14.6 5.50009C17.18 6.53009 19 9.06008 19 12.0001C19 14.9401 17.18 17.4701 14.6 18.5001C14.24 18.6401 14 18.9701 14 19.3501V19.5501C14 20.1801 14.63 20.6201 15.21 20.4001C18.6 19.1101 21 15.8401 21 12.0001C21 8.16008 18.6 4.89008 15.21 3.60009C14.63 3.37009 14 3.82008 14 4.45008Z"
    fill={color}
  />
);

export const VolumeMute: React.FC<Props> = ({ color }) => (
  <path
    d="M7 9.99977V13.9998C7 14.5498 7.45 14.9998 8 14.9998H11L14.29 18.2898C14.92 18.9198 16 18.4698 16 17.5798V6.40977C16 5.51977 14.92 5.06977 14.29 5.69977L11 8.99977H8C7.45 8.99977 7 9.44977 7 9.99977Z"
    fill={color}
  />
);

export const VolumeOff: React.FC<Props> = ({ color }) => (
  <path
    d="M3.63 3.6299C3.24 4.0199 3.24 4.6499 3.63 5.0399L7.29 8.6999L7 8.9999H4C3.45 8.9999 3 9.4499 3 9.9999V13.9999C3 14.5499 3.45 14.9999 4 14.9999H7L10.29 18.2899C10.92 18.9199 12 18.4699 12 17.5799V13.4099L16.18 17.5899C15.69 17.9599 15.16 18.2699 14.58 18.4999C14.22 18.6499 14 19.0299 14 19.4199C14 20.1399 14.73 20.5999 15.39 20.3299C16.19 19.9999 16.94 19.5599 17.61 19.0199L18.95 20.3599C19.34 20.7499 19.97 20.7499 20.36 20.3599C20.75 19.9699 20.75 19.3399 20.36 18.9499L5.05 3.6299C4.66 3.2399 4.03 3.2399 3.63 3.6299ZM19 11.9999C19 12.8199 18.85 13.6099 18.59 14.3399L20.12 15.8699C20.68 14.6999 21 13.3899 21 11.9999C21 8.1699 18.6 4.8899 15.22 3.5999C14.63 3.3699 14 3.8299 14 4.4599V4.6499C14 5.0299 14.25 5.3599 14.61 5.4999C17.18 6.5399 19 9.0599 19 11.9999ZM10.29 5.7099L10.12 5.8799L12 7.7599V6.4099C12 5.5199 10.92 5.0799 10.29 5.7099ZM16.5 11.9999C16.5 10.2299 15.48 8.7099 14 7.9699V9.7599L16.48 12.2399C16.49 12.1599 16.5 12.0799 16.5 11.9999Z"
    fill={color}
  />
);

export const Add: React.FC<Props> = ({ color }) => (
  <path
    d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
    fill={color}
  />
);

export const Dashboard: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88852)">
      <path
        d="M4 13H10C10.55 13 11 12.55 11 12V4C11 3.45 10.55 3 10 3H4C3.45 3 3 3.45 3 4V12C3 12.55 3.45 13 4 13ZM4 21H10C10.55 21 11 20.55 11 20V16C11 15.45 10.55 15 10 15H4C3.45 15 3 15.45 3 16V20C3 20.55 3.45 21 4 21ZM14 21H20C20.55 21 21 20.55 21 20V12C21 11.45 20.55 11 20 11H14C13.45 11 13 11.45 13 12V20C13 20.55 13.45 21 14 21ZM13 4V8C13 8.55 13.45 9 14 9H20C20.55 9 21 8.55 21 8V4C21 3.45 20.55 3 20 3H14C13.45 3 13 3.45 13 4Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88852">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Download: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_90704)">
      <path
        d="M16.59 9H15V4C15 3.45 14.55 3 14 3H10C9.45 3 9 3.45 9 4V9H7.41C6.52 9 6.07 10.08 6.7 10.71L11.29 15.3C11.68 15.69 12.31 15.69 12.7 15.3L17.29 10.71C17.92 10.08 17.48 9 16.59 9ZM5 19C5 19.55 5.45 20 6 20H18C18.55 20 19 19.55 19 19C19 18.45 18.55 18 18 18H6C5.45 18 5 18.45 5 19Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_90704">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const HeartBorder: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88945)">
      <path
        d="M19.6602 3.99017C17.0202 2.19017 13.7602 3.03017 12.0002 5.09017C10.2402 3.03017 6.98021 2.18017 4.34021 3.99017C2.94021 4.95017 2.06021 6.57017 2.00021 8.28017C1.86021 12.1602 5.30021 15.2702 10.5502 20.0402L10.6502 20.1302C11.4102 20.8202 12.5802 20.8202 13.3402 20.1202L13.4502 20.0202C18.7002 15.2602 22.1302 12.1502 22.0002 8.27017C21.9402 6.57017 21.0602 4.95017 19.6602 3.99017ZM12.1002 18.5502L12.0002 18.6502L11.9002 18.5502C7.14021 14.2402 4.00021 11.3902 4.00021 8.50017C4.00021 6.50017 5.50021 5.00017 7.50021 5.00017C9.04021 5.00017 10.5402 5.99017 11.0702 7.36017H12.9402C13.4602 5.99017 14.9602 5.00017 16.5002 5.00017C18.5002 5.00017 20.0002 6.50017 20.0002 8.50017C20.0002 11.3902 16.8602 14.2402 12.1002 18.5502Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88945">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Upload: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_90739)">
      <path
        d="M10 16.0002H14C14.55 16.0002 15 15.5502 15 15.0002V10.0002H16.59C17.48 10.0002 17.93 8.92021 17.3 8.29021L12.71 3.70021C12.32 3.31021 11.69 3.31021 11.3 3.70021L6.71 8.29021C6.08 8.92021 6.52 10.0002 7.41 10.0002H9V15.0002C9 15.5502 9.45 16.0002 10 16.0002ZM6 18.0002H18C18.55 18.0002 19 18.4502 19 19.0002C19 19.5502 18.55 20.0002 18 20.0002H6C5.45 20.0002 5 19.5502 5 19.0002C5 18.4502 5.45 18.0002 6 18.0002Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_90739">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Code: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88819)">
      <path
        d="M8.69998 15.9002L4.79998 12.0002L8.69998 8.10022C9.08998 7.71022 9.08998 7.09021 8.69998 6.70021C8.30998 6.31021 7.68998 6.31021 7.29998 6.70021L2.70998 11.2902C2.31998 11.6802 2.31998 12.3102 2.70998 12.7002L7.29998 17.3002C7.68998 17.6902 8.30998 17.6902 8.69998 17.3002C9.08998 16.9102 9.08998 16.2902 8.69998 15.9002ZM15.3 15.9002L19.2 12.0002L15.3 8.10022C14.91 7.71022 14.91 7.09021 15.3 6.70021C15.69 6.31021 16.31 6.31021 16.7 6.70021L21.29 11.2902C21.68 11.6802 21.68 12.3102 21.29 12.7002L16.7 17.3002C16.31 17.6902 15.69 17.6902 15.3 17.3002C14.91 16.9102 14.91 16.2902 15.3 15.9002Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88819">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Analytics: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88663)">
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM8 17C7.45 17 7 16.55 7 16V13C7 12.45 7.45 12 8 12C8.55 12 9 12.45 9 13V16C9 16.55 8.55 17 8 17ZM12 17C11.45 17 11 16.55 11 16V15C11 14.45 11.45 14 12 14C12.55 14 13 14.45 13 15V16C13 16.55 12.55 17 12 17ZM12 12C11.45 12 11 11.55 11 11C11 10.45 11.45 10 12 10C12.55 10 13 10.45 13 11C13 11.55 12.55 12 12 12ZM16 17C15.45 17 15 16.55 15 16V8C15 7.45 15.45 7 16 7C16.55 7 17 7.45 17 8V16C17 16.55 16.55 17 16 17Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88663">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Bookmark: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88747)">
      <path
        d="M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88747">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const BookmarkBorder: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88753)">
      <path
        d="M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V6C7 5.45 7.45 5 8 5H16C16.55 5 17 5.45 17 6V18Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88753">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Heart: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88942)">
      <path
        d="M13.3502 20.1302C12.5902 20.8202 11.4202 20.8202 10.6602 20.1202L10.5502 20.0202C5.30015 15.2702 1.87015 12.1602 2.00015 8.28017C2.06015 6.58017 2.93015 4.95017 4.34015 3.99017C6.98015 2.19017 10.2402 3.03017 12.0002 5.09017C13.7602 3.03017 17.0202 2.18017 19.6602 3.99017C21.0702 4.95017 21.9402 6.58017 22.0002 8.28017C22.1402 12.1602 18.7002 15.2702 13.4502 20.0402L13.3502 20.1302Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88942">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Translate: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_89009)">
      <path
        d="M20 5H10.88L10 2H4C2.9 2 2 2.9 2 4V17C2 18.1 2.9 19 4 19H11L12 22H20C21.1 22 22 21.1 22 20V7C22 5.9 21.1 5 20 5ZM7.17 14.59C4.92 14.59 3.08 12.76 3.08 10.5C3.08 8.24 4.91 6.41 7.17 6.41C8.21 6.41 9.16 6.78 9.91 7.48L9.98 7.54L8.75 8.72L8.69 8.67C8.4 8.4 7.91 8.08 7.17 8.08C5.86 8.08 4.79 9.17 4.79 10.5C4.79 11.83 5.86 12.92 7.17 12.92C8.54 12.92 9.13 12.05 9.29 11.46H7.08V9.91H11.03L11.04 9.98C11.08 10.19 11.09 10.38 11.09 10.59C11.09 12.94 9.48 14.59 7.17 14.59ZM13.2 12.88C13.53 13.48 13.94 14.06 14.39 14.58L13.85 15.11L13.2 12.88ZM13.97 12.12H12.98L12.67 11.08H16.66C16.66 11.08 16.32 12.39 15.1 13.82C14.58 13.2 14.21 12.59 13.97 12.12ZM21 20C21 20.55 20.55 21 20 21H13L15 19L14.19 16.23L15.11 15.31L17.79 18L18.52 17.27L15.81 14.59C16.71 13.56 17.41 12.34 17.73 11.08H19V10.04H15.36V9H14.32V10.04H12.36L11.18 6H20C20.55 6 21 6.45 21 7V20Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_89009">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Gif: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88989)">
      <path
        d="M12.25 9C12.66 9 13 9.34 13 9.75V14.25C13 14.66 12.66 15 12.25 15C11.84 15 11.5 14.66 11.5 14.25V9.75C11.5 9.34 11.84 9 12.25 9ZM10 9.75C10 9.34 9.66 9 9.25 9H6C5.4 9 5 9.5 5 10V14C5 14.5 5.4 15 6 15H9C9.6 15 10 14.5 10 14V12.75C10 12.34 9.66 12 9.25 12C8.84 12 8.5 12.34 8.5 12.75V13.5H6.5V10.5H9.25C9.66 10.5 10 10.16 10 9.75ZM19 9.75C19 9.34 18.66 9 18.25 9H15.5C14.95 9 14.5 9.45 14.5 10V14.25C14.5 14.66 14.84 15 15.25 15C15.66 15 16 14.66 16 14.25V13H17.25C17.66 13 18 12.66 18 12.25C18 11.84 17.66 11.5 17.25 11.5H16V10.5H18.25C18.66 10.5 19 10.16 19 9.75Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88989">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Grade: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88992)">
      <path
        d="M11.9998 17.2702L17.1698 20.3902C17.5498 20.6202 18.0198 20.2802 17.9198 19.8502L16.5498 13.9702L21.1098 10.0202C21.4398 9.73022 21.2698 9.18022 20.8198 9.14022L14.8098 8.63022L12.4598 3.09021C12.2898 2.68021 11.7098 2.68021 11.5398 3.09021L9.18981 8.63022L3.17981 9.14022C2.73981 9.18022 2.55981 9.73022 2.89981 10.0202L7.45981 13.9702L6.08981 19.8502C5.98981 20.2802 6.45981 20.6202 6.83981 20.3902L11.9998 17.2702Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88992">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Language: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_89103)">
      <path
        d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.35 18.92 8ZM12 4.04C12.83 5.24 13.48 6.57 13.91 8H10.09C10.52 6.57 11.17 5.24 12 4.04ZM4.26 14C4.1 13.36 4 12.69 4 12C4 11.31 4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12C7.5 12.68 7.56 13.34 7.64 14H4.26ZM5.08 16H8.03C8.35 17.25 8.81 18.45 9.41 19.56C7.57 18.93 6.04 17.66 5.08 16ZM8.03 8H5.08C6.04 6.34 7.57 5.07 9.41 4.44C8.81 5.55 8.35 6.75 8.03 8ZM12 19.96C11.17 18.76 10.52 17.43 10.09 16H13.91C13.48 17.43 12.83 18.76 12 19.96ZM14.34 14H9.66C9.57 13.34 9.5 12.68 9.5 12C9.5 11.32 9.57 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.68 14.43 13.34 14.34 14ZM14.59 19.56C15.19 18.45 15.65 17.25 15.97 16H18.92C17.96 17.65 16.43 18.93 14.59 19.56ZM16.36 14C16.44 13.34 16.5 12.68 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.69 19.9 13.36 19.74 14H16.36Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_89103">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Launch: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_89106)">
      <path
        d="M18 19H6C5.45 19 5 18.55 5 18V6C5 5.45 5.45 5 6 5H11C11.55 5 12 4.55 12 4C12 3.45 11.55 3 11 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V13C21 12.45 20.55 12 20 12C19.45 12 19 12.45 19 13V18C19 18.55 18.55 19 18 19ZM14 4C14 4.55 14.45 5 15 5H17.59L8.46 14.13C8.07 14.52 8.07 15.15 8.46 15.54C8.85 15.93 9.48 15.93 9.87 15.54L19 6.41V9C19 9.55 19.45 10 20 10C20.55 10 21 9.55 21 9V3H15C14.45 3 14 3.45 14 4Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_89106">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const ShoppingCart: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_89438)">
      <path
        d="M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM1 3C1 3.55 1.45 4 2 4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H18C18.55 17 19 16.55 19 16C19 15.45 18.55 15 18 15H7L8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.54 2.57C4.38 2.22 4.02 2 3.64 2H2C1.45 2 1 2.45 1 3ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_89438">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const ViewList: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_89649)">
      <path
        d="M4 14H6C6.55 14 7 13.55 7 13V11C7 10.45 6.55 10 6 10H4C3.45 10 3 10.45 3 11V13C3 13.55 3.45 14 4 14ZM4 19H6C6.55 19 7 18.55 7 18V16C7 15.45 6.55 15 6 15H4C3.45 15 3 15.45 3 16V18C3 18.55 3.45 19 4 19ZM4 9H6C6.55 9 7 8.55 7 8V6C7 5.45 6.55 5 6 5H4C3.45 5 3 5.45 3 6V8C3 8.55 3.45 9 4 9ZM9 14H19C19.55 14 20 13.55 20 13V11C20 10.45 19.55 10 19 10H9C8.45 10 8 10.45 8 11V13C8 13.55 8.45 14 9 14ZM9 19H19C19.55 19 20 18.55 20 18V16C20 15.45 19.55 15 19 15H9C8.45 15 8 15.45 8 16V18C8 18.55 8.45 19 9 19ZM8 6V8C8 8.55 8.45 9 9 9H19C19.55 9 20 8.55 20 8V6C20 5.45 19.55 5 19 5H9C8.45 5 8 5.45 8 6Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_89649">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Visibility: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_89668)">
      <path
        d="M12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 8.74 9.24 6.5 12 6.5C14.76 6.5 17 8.74 17 11.5C17 14.26 14.76 16.5 12 16.5ZM12 8.5C10.34 8.5 9 9.84 9 11.5C9 13.16 10.34 14.5 12 14.5C13.66 14.5 15 13.16 15 11.5C15 9.84 13.66 8.5 12 8.5Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_89668">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const VisibilityOff: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_89671)">
      <path
        d="M12 6.50018C14.76 6.50018 17 8.74018 17 11.5002C17 12.0102 16.9 12.5002 16.76 12.9602L19.82 16.0202C21.21 14.7902 22.31 13.2502 23 11.4902C21.27 7.11018 17 4.00018 12 4.00018C10.73 4.00018 9.51 4.20018 8.36 4.57018L10.53 6.74018C11 6.60018 11.49 6.50018 12 6.50018ZM2.71 3.16018C2.32 3.55018 2.32 4.18018 2.71 4.57018L4.68 6.54018C3.06 7.83018 1.77 9.53018 1 11.5002C2.73 15.8902 7 19.0002 12 19.0002C13.52 19.0002 14.97 18.7002 16.31 18.1802L19.03 20.9002C19.42 21.2902 20.05 21.2902 20.44 20.9002C20.83 20.5102 20.83 19.8802 20.44 19.4902L4.13 3.16018C3.74 2.77018 3.1 2.77018 2.71 3.16018ZM12 16.5002C9.24 16.5002 7 14.2602 7 11.5002C7 10.7302 7.18 10.0002 7.49 9.36018L9.06 10.9302C9.03 11.1102 9 11.3002 9 11.5002C9 13.1602 10.34 14.5002 12 14.5002C12.2 14.5002 12.38 14.4702 12.57 14.4302L14.14 16.0002C13.49 16.3202 12.77 16.5002 12 16.5002ZM14.97 11.1702C14.82 9.77018 13.72 8.68018 12.33 8.53018L14.97 11.1702Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_89671">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const ZoomIn: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_89709)">
      <path
        d="M15.4999 14.0001H14.7099L14.4299 13.7301C15.6299 12.3301 16.2499 10.4201 15.9099 8.39014C15.4399 5.61014 13.1199 3.39014 10.3199 3.05014C6.0899 2.53014 2.5399 6.09014 3.0499 10.3201C3.3899 13.1201 5.6099 15.4401 8.3899 15.9101C10.4199 16.2501 12.3299 15.6301 13.7299 14.4301L13.9999 14.7101V15.5001L18.2599 19.7501C18.6699 20.1601 19.3299 20.1601 19.7399 19.7501L19.7499 19.7401C20.1599 19.3301 20.1599 18.6701 19.7499 18.2601L15.4999 14.0001ZM9.4999 14.0001C7.0099 14.0001 4.9999 11.9901 4.9999 9.50014C4.9999 7.01014 7.0099 5.00014 9.4999 5.00014C11.9899 5.00014 13.9999 7.01014 13.9999 9.50014C13.9999 11.9901 11.9899 14.0001 9.4999 14.0001ZM9.4999 7.00014C9.2199 7.00014 8.9999 7.22014 8.9999 7.50014V9.00014H7.4999C7.2199 9.00014 6.9999 9.22014 6.9999 9.50014C6.9999 9.78014 7.2199 10.0001 7.4999 10.0001H8.9999V11.5001C8.9999 11.7801 9.2199 12.0001 9.4999 12.0001C9.7799 12.0001 9.9999 11.7801 9.9999 11.5001V10.0001H11.4999C11.7799 10.0001 11.9999 9.78014 11.9999 9.50014C11.9999 9.22014 11.7799 9.00014 11.4999 9.00014H9.9999V7.50014C9.9999 7.22014 9.7799 7.00014 9.4999 7.00014Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_89709">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const ZoomOut: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_89712)">
      <path
        d="M15.5001 14.0001H14.7101L14.4301 13.7301C15.6301 12.3301 16.2501 10.4201 15.9101 8.39014C15.4401 5.61014 13.1201 3.39014 10.3201 3.05014C6.09014 2.53014 2.53014 6.09014 3.05014 10.3201C3.39014 13.1201 5.61014 15.4401 8.39014 15.9101C10.4201 16.2501 12.3301 15.6301 13.7301 14.4301L14.0001 14.7101V15.5001L18.2601 19.7501C18.6701 20.1601 19.3301 20.1601 19.7401 19.7501L19.7501 19.7401C20.1601 19.3301 20.1601 18.6701 19.7501 18.2601L15.5001 14.0001ZM9.50014 14.0001C7.01014 14.0001 5.00014 11.9901 5.00014 9.50014C5.00014 7.01014 7.01014 5.00014 9.50014 5.00014C11.9901 5.00014 14.0001 7.01014 14.0001 9.50014C14.0001 11.9901 11.9901 14.0001 9.50014 14.0001ZM7.50014 9.00014H11.5001C11.7801 9.00014 12.0001 9.22014 12.0001 9.50014C12.0001 9.78014 11.7801 10.0001 11.5001 10.0001H7.50014C7.22014 10.0001 7.00014 9.78014 7.00014 9.50014C7.00014 9.22014 7.22014 9.00014 7.50014 9.00014Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_89712">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const AccountBox: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88621)">
      <path
        d="M3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H5C3.89 3 3 3.9 3 5ZM15 9C15 10.66 13.66 12 12 12C10.34 12 9 10.66 9 9C9 7.34 10.34 6 12 6C13.66 6 15 7.34 15 9ZM6 17C6 15 10 13.9 12 13.9C14 13.9 18 15 18 17V18H6V17Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88621">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const AccountCircle: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88624)">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88624">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const AddShoppingCart: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88631)">
      <path
        d="M12 9C12.55 9 13 8.55 13 8V6H15C15.55 6 16 5.55 16 5C16 4.45 15.55 4 15 4H13V2C13 1.45 12.55 1 12 1C11.45 1 11 1.45 11 2V4H9C8.45 4 8 4.45 8 5C8 5.55 8.45 6 9 6H11V8C11 8.55 11.45 9 12 9ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18ZM8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L20.68 5.84C20.95 5.36 20.77 4.75 20.29 4.48C19.81 4.22 19.2 4.39 18.94 4.87L15.55 11H8.53L4.54 2.57C4.38 2.22 4.02 2 3.64 2H2C1.45 2 1 2.45 1 3C1 3.55 1.45 4 2 4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H18C18.55 17 19 16.55 19 16C19 15.45 18.55 15 18 15H7L8.1 13Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88631">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const AddChart: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_88627)">
      <path
        d="M11 10C11 9.45 11.45 9 12 9C12.55 9 13 9.45 13 10V17H11V10ZM20 13C19.45 13 19 13.45 19 14V19H5V5H10C10.55 5 11 4.55 11 4C11 3.45 10.55 3 10 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V14C21 13.45 20.55 13 20 13ZM21 5H19V3C19 2.45 18.55 2 18 2C17.45 2 17 2.45 17 3V5H15C14.45 5 14 5.45 14 6C14 6.55 14.45 7 15 7H17V9C17 9.55 17.45 10 18 10C18.55 10 19 9.55 19 9V7H21C21.55 7 22 6.55 22 6C22 5.45 21.55 5 21 5ZM16 13C15.45 13 15 13.45 15 14V17H17V14C17 13.45 16.55 13 16 13ZM7 12V17H9V12C9 11.45 8.55 11 8 11C7.45 11 7 11.45 7 12Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_88627">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const ExpandDown: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_208_81878)">
      <path
        d="M16.59 8.58997L12 13.17L7.41 8.58997L6 9.99997L12 16L18 9.99997L16.59 8.58997Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_208_81878">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const Account: React.FC<Props> = ({ color }) => (
  <path
    d="M15.71,12.71a6,6,0,1,0-7.42,0,10,10,0,0,0-6.22,8.18,1,1,0,0,0,2,.22,8,8,0,0,1,15.9,0,1,1,0,0,0,1,.89h.11a1,1,0,0,0,.88-1.1A10,10,0,0,0,15.71,12.71ZM12,12a4,4,0,1,1,4-4A4,4,0,0,1,12,12Z"
    fill={color}
  ></path>
);

export const Eye: React.FC<Props> = ({ color }) => (
  <>
    <path
      d="M22.0999 12.235C21.9718 12.7326 21.6131 13.0759 21.2855 13.4381C19.9575 14.9056 18.4763 16.189 16.7411 17.1637C15.5043 17.8586 14.1926 18.3352 12.7699 18.4649C11.3982 18.5898 10.0728 18.3783 8.79334 17.8802C6.9797 17.1747 5.42206 16.073 4.02193 14.7466C3.40457 14.1614 2.82934 13.5294 2.25992 12.8959C1.79215 12.3752 1.78162 11.6792 2.2183 11.1532C3.71114 9.35762 5.42838 7.82233 7.50488 6.71797C8.75699 6.05242 10.0792 5.60574 11.5067 5.51599C13.1075 5.41521 14.6067 5.79732 16.0384 6.48125C17.8815 7.36148 19.4423 8.6191 20.8456 10.083C21.0453 10.2914 21.2354 10.5082 21.4298 10.7218C21.7111 11.032 21.9903 11.3438 22.1004 11.7632C22.0999 11.9206 22.0999 12.0781 22.0999 12.235ZM16.3529 12.0067C16.3582 9.61271 14.4165 7.67274 12.0113 7.66959C9.60613 7.66644 7.66133 9.59906 7.65816 11.9946C7.655 14.3902 9.59349 16.3276 11.9992 16.3333C14.4002 16.3391 16.3476 14.4033 16.3529 12.0067Z"
      fill={color}
    />
    <path
      d="M15.1161 11.9946C15.1188 13.7 13.7223 15.0967 12.0119 15.0999C10.301 15.1025 8.89876 13.7105 8.89612 12.0067C8.89349 10.3014 10.2894 8.90517 12.0003 8.90149C13.7107 8.89835 15.1135 10.2909 15.1161 11.9946Z"
      fill={color}
    />
  </>
);

export const EyeClose: React.FC<Props> = ({ color }) => (
  <>
    <g clipPath="url(#clip0_282_3680)">
      <path
        d="M2.00052 11.2062C2.2921 10.3694 2.86952 9.74062 3.41095 9.09098C4.03949 8.33708 4.76087 7.68689 5.54015 7.10912C5.58136 7.07839 5.61944 7.04273 5.6742 6.99609C5.29082 6.59665 4.91161 6.21202 4.54388 5.81587C4.27577 5.52671 4.26638 5.09215 4.50215 4.78653C4.7254 4.49682 5.12912 4.41232 5.43635 4.59998C5.51929 4.65045 5.59388 4.72123 5.66221 4.79311C9.13246 8.44078 12.6012 12.0901 16.0704 15.7389C16.8204 16.5279 17.5689 17.3174 18.3216 18.1037C18.5355 18.327 18.6482 18.5822 18.5751 18.8993C18.4364 19.5001 17.7541 19.7031 17.329 19.2647C16.762 18.6804 16.2029 18.0872 15.6458 17.493C15.5608 17.4019 15.4898 17.3866 15.3745 17.4244C12.174 18.4872 9.13559 18.073 6.25997 16.2854C4.63829 15.2774 3.32019 13.9222 2.26393 12.2849C2.15022 12.1082 2.08659 11.8953 2 11.6994C2.00052 11.5348 2.00052 11.3702 2.00052 11.2062ZM8.18001 9.64296C7.50974 11.0311 7.65005 13.1633 9.05057 14.6091C10.4307 16.0346 12.4358 16.1575 13.7153 15.4656C13.3439 15.0755 12.9788 14.6887 12.6079 14.3084C12.5761 14.2755 12.501 14.2728 12.4494 14.2805C12.0649 14.3403 11.6847 14.3271 11.3081 14.2212C9.95139 13.8404 9.12985 12.5258 9.30198 11.0147C9.30981 10.9461 9.31555 10.8484 9.27903 10.8084C8.91965 10.4161 8.55087 10.0336 8.18001 9.64296Z"
        fill={color}
      />
      <path
        d="M18.2952 15.9002C18.1502 15.7389 18.0067 15.5715 17.856 15.4124C17.2274 14.7479 16.5989 14.0829 15.9636 13.4261C15.8593 13.318 15.8441 13.2368 15.8984 13.0931C16.987 10.1861 14.9991 7.06521 12.0348 7.02461C11.4694 7.01693 10.9248 7.13654 10.3975 7.35108C10.3354 7.37632 10.2228 7.37248 10.1821 7.33023C9.62396 6.7563 9.07418 6.17305 8.52336 5.59144C8.51137 5.57882 8.50719 5.55797 8.47485 5.48993C9.06949 5.34233 9.64221 5.16401 10.2269 5.0625C11.9284 4.76841 13.6101 4.87869 15.2563 5.43671C17.6421 6.24547 19.5794 7.73132 21.1395 9.77847C21.3549 10.061 21.5615 10.3524 21.7508 10.6547C22.0763 11.1738 22.0878 11.7159 21.7602 12.2338C20.8573 13.6632 19.7275 14.8615 18.389 15.8431C18.3687 15.8579 18.3458 15.8694 18.2952 15.9002Z"
        fill={color}
      />
      <path
        d="M11.4652 8.63831C12.4844 8.4737 13.3487 8.75518 14.0294 9.55571C14.6225 10.2536 14.8212 11.08 14.6658 12.0067C13.596 10.8802 12.5402 9.7697 11.4652 8.63831Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_282_3680">
        <rect
          width="20"
          height="15"
          fill="white"
          transform="translate(2 4.5)"
        />
      </clipPath>
    </defs>
  </>
);

export const IconList = {
  search: Search,
  done: Done,
  forwardArrowIOS: ForwardArrowIOS,
  backArrowIOS: BackArrowIOS,
  arrowDropdown: ArrowDropdown,
  arrowDropUp: ArrowDropUp,
  check: Check,
  close: Close,
  mail: Mail,
  photo: Photo,
  photoLibrary: PhotoLibrary,
  addPhotoAlt: AddPhotoAlt,
  copyContent: CopyContent,
  copyFile: CopyFile,
  mic: Mic,
  micNone: MicNone,
  micOff: MicOff,
  pause: Pause,
  play: Play,
  save: Save,
  send: Send,
  sort: Sort,
  volumeDown: VolumeDown,
  volumeUp: VolumeUp,
  volumeMute: VolumeMute,
  volumeOff: VolumeOff,
  add: Add,
  dashBoard: Dashboard,
  download: Download,
  heartBorder: HeartBorder,
  upload: Upload,
  code: Code,
  analytics: Analytics,
  heart: Heart,
  bookmark: Bookmark,
  bookmarkBorder: BookmarkBorder,
  translate: Translate,
  gif: Gif,
  grade: Grade,
  language: Language,
  launch: Launch,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
  viewList: ViewList,
  visibility: Visibility,
  visibilityOff: VisibilityOff,
  shoppingCart: ShoppingCart,
  addShoppingCart: AddShoppingCart,
  account: Account,
  accountBox: AccountBox,
  accountCircle: AccountCircle,
  addChart: AddChart,
  expandDown: ExpandDown,
  eye: Eye,
  eyeClose: EyeClose,
};

const IconType = Object.keys(IconList) as (keyof typeof IconList)[];
export type IconName = (typeof IconType)[number];
